module.exports = __webpack_public_path__ + "static/img/banner-word-ft.5ccdc4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/img/banner-word-ft.png
// module id = Zfil
// module chunks = 97